import React from 'react'
import AdvancedSearch from '../advanced-search'

const AdvancedSearchPl = () => {
    return <AdvancedSearch languageCode="pl" />
}

export default AdvancedSearchPl
